import { render } from "./SupportType.vue?vue&type=template&id=fa22120e"
import script from "./SupportType.vue?vue&type=script&lang=js"
export * from "./SupportType.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./SupportType.vue?vue&type=style&index=0&id=fa22120e&module=true&lang=scss"
cssModules["$style"] = style0

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules]])

export default __exports__